export default "__VITE_ASSET__YPH3xzZt__"